/**
 * A new deploy (see `helpers/app-update.ts`) for function components.
 */
import {useEffect, useSyncExternalStore} from 'react';

import {blockAutoReload, getDeployedBuildId, subscribe} from '../helpers/app-update';

/** Whether a newer build than this one is deployed: re-renders when one is noticed. */
export const useUpdateAvailable = (): boolean => null !== useSyncExternalStore(subscribe, getDeployedBuildId);

/**
 * Keep the page from reloading by itself for a new version while `blocked`, e.g. while the operator is busy. The page
 * reloads as soon as nothing blocks it any more, once the new version was offered long enough.
 */
export const useBlockAutoReload = (blocked: boolean): void => {
    useEffect(() => (blocked ? blockAutoReload() : undefined), [blocked]);
};
